import { DefaultButton, Icon, IconButton, IIconProps, Link, TooltipHost } from "@fluentui/react";
import { useState } from "react";
import styles from './PodPlaceholder.module.scss';

interface PlaceholderAction {
  iconName?: string,
  text: string,
  disabled?: boolean,
  disabledTooltip?: string,
  onClick: React.MouseEventHandler<DefaultButton>,
}

interface Props {
  full?: boolean,
  iconName?: string,
  text: React.ReactNode,
  type?: "default" | "error",
  action?: PlaceholderAction,
  output?: string,
}

const PodPlaceholder = ({iconName, text, full, type, action, output}: Props) => {
  const [showOutput, setShowOutput] = useState(false);

  const buttonIconProps: { iconProps: IIconProps } | undefined = action && action.iconName
    ? { iconProps: {iconName: action.iconName, className: styles.actionButtonIcon } }
    : undefined;

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
    }
  }

  return (
    <div className={`${styles.placeholder}${full ? ` ${styles.fullHeight}` : ''}`}>
      <div className={`${styles.iconFrame}${type === "error" ? ` ${styles.error}`: ''}`}>
        <Icon iconName={iconName ?? "Search"} />
      </div>
      <span className={styles.text}>{text}</span>
      {action && (
        <div className={styles.action}>
          <TooltipHost
            content={action.disabled ? action.disabledTooltip ?? '' : ''}
            styles={{ root: { display: 'inline-block' } }}
          >
            <DefaultButton {...buttonIconProps} className={styles.actionButton} disabled={action.disabled} text={action.text} onClick={action.onClick}/>
          </TooltipHost>
        </div>
      )}
      {output && (
        <div className={styles.output}>
          <div className={styles.outputToggle}>
            <Link
              onClick={() => setShowOutput(prev => !prev)}
            >
              {`${showOutput ? 'Hide' : 'Show'} debug information`}
            </Link>
          </div>
          <div className={styles.outputContents} style={{ display: showOutput ? 'block' : 'none' }}>
            <div className={styles.copyButton}>
              <TooltipHost content="Copy debug information">
                <IconButton iconProps={{ iconName: "Copy" }} ariaLabel="Copy debug information" onClick={copyOutput}/>
              </TooltipHost>
            </div>
            <samp>
              {output}
            </samp>
          </div>
        </div>
      )}
    </div>
  );
};

export default PodPlaceholder